(function (angular) {
    'use strict';

    angular.module('broadcast')

        .component('step4', {
            bindings: {
                forms: "="
            },
            controller: ["broadcastWizardService", "WizardHandler",
                function (broadcastWizardService, WizardHandler) {

                    var ctrl = this;
                    ctrl.bws = broadcastWizardService;

                    function updateAndNavigate(navFunc) {
                        ctrl.showInvalid = true;

                        if (ctrl.forms.step4Form.$valid) {
                            broadcastWizardService.updateBroadcast()
                                .then(function (succeeded) {
                                    if (succeeded) {
                                        navFunc();
                                    }
                                });
                        }
                    }

                    ctrl.prev = function () {
                        updateAndNavigate(WizardHandler.wizard("broadcastWizard").previous);
                    }

                    ctrl.next = function () {
                        updateAndNavigate(WizardHandler.wizard("broadcastWizard").next);
                    }


                }],
            templateUrl: 'components/toolkit/broadcast/templates/step4.html',
        })
})(window.angular);